// motion-init.js
// Wires the decoupled data-motion pattern to the choreography runtime.
// No Alpine dependency — for components that want to stay framework-agnostic.
//
//   <div data-motion="modal-enter" data-motion-exit="modal-exit">
//     <button data-motion-trigger="open">Open</button>
//     <button data-motion-trigger="close">Close</button>
//   </div>

import { run } from './motion-choreography.js';

function initMotionRoots(scope = document) {
  scope.querySelectorAll('[data-motion]').forEach(root => {
    if (root.__motionInitialized) return;
    root.__motionInitialized = true;

    const enterToken = root.dataset.motion;
    const exitToken = root.dataset.motionExit
      || (enterToken.endsWith('-enter') ? enterToken.replace(/-enter$/, '-exit') : null);

    root.querySelectorAll('[data-motion-trigger="open"]').forEach(el => {
      el.addEventListener('click', () => {
        root.dataset.motionState = 'open';
        run(`choreography-${enterToken}`, root);
      });
    });

    if (exitToken) {
      root.querySelectorAll('[data-motion-trigger="close"]').forEach(el => {
        el.addEventListener('click', async () => {
          await run(`choreography-${exitToken}`, root);
          root.dataset.motionState = 'closed';
        });
      });
    }
  });
}

// Auto-init on DOM ready and observe for dynamically added roots.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initMotionRoots());
} else {
  initMotionRoots();
}

if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) initMotionRoots(node.parentNode || document);
      }
    }
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
}

export { initMotionRoots };
